import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionNonFinal: {
		id: 'periscope.header.info-banner.description-non-final',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			"<strong>We'd like to hear from you.</strong> This feature is in internal dogfooding. Help us improve it by sharing your experience at <slack>#help-periscope</slack>",
		description:
			'This is the description for a banner which describes what the Periscope/Development feature is. This currently lets the user know that this feature is still in an early stage of development.',
	},
});
